<sk-modal-content
  [title]="'label.Imprint' | translate"
  (closed)="closeWithoutResult()"
  [isHideCloseBtn]="true">
  <ng-container id="sk-modal-body">
    <div class="host-frame-container">
      <iframe
        width="100%"
        height="100%"
        class="host-frame"
        [title]="'label.Imprint' | translate"
        [src]="path | safeResourceUrl"
        sandbox
      ></iframe>
    </div>
  </ng-container>
  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [appearance]="'text'"
      [color]="'primary'"
      type="button"
      [label]="'label.Close' | translate"
      (click)="closeWithoutResult()"
      data-test="imprint-footer-button">
      <ng-template buttonPrefix>
        <i class="fa-fw fal fa-times"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
